<template>
  <div class="w-full col-span-full" @click="$emit('click')">
    <info-bulle
      v-if="libelle || replaceTooltipLibelle"
      :libelle="labelLibelle"
      :name="name"
      :is-libelle-input="true"
    >
      <template #libelleBefore>
        <div
          :for="name"
          :class="libelleStyle + ' truncate mb-2 flex items-center gap-x-1'"
          :style="
            inherits != undefined && inherits != null && inherits
              ? 'color: inherit; font-size: inherit; font-weight: inherit;'
              : ''
          "
          @mouseover="tooltipLibelle = true"
          @mouseleave="tooltipLibelle = false"
        >
          {{ libelle }} <span v-if="required" class="text-pink-600">*</span>
          <div
            v-if="libelleIcon"
            @click.stop="$emit('clickIcon')"
            class="cursor-pointer"
          >
            <icon :name="libelleIcon" :class="libelleIconStyle" />
          </div>
        </div>
      </template>
      <template #tooltipLibelleBefore>
        <!-- Display libelle when hover -->
        <transition
          enter-active-class="duration-300 delay-1000"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="duration-300"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="
              tooltipLibelle &&
              ((libelle != null && libelle != '') ||
                (replaceTooltipLibelle != null && replaceTooltipLibelle != ''))
            "
            class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 z-30 p-3 text-sm w-max-content w-max max-w-128"
          >
            {{ replaceTooltipLibelle ? replaceTooltipLibelle : libelle }}
          </div>
        </transition>
      </template>
    </info-bulle>

    <div
      class="relative"
      @mouseover="tooltipValue = true"
      @mouseleave="tooltipValue = false"
    >
      <input
        :type="typeField"
        :name="name"
        :min="min"
        :max="max"
        :necessary="progressCount"
        :required="isRequired"
        :autocomplete="
          typeField == 'password' && newPassword ? 'new-password' : 'off'
        "
        class="bg-white border border-opacity-50 rounded-md placeholder-gray-600 block w-full focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 appearance-none transition duration-150 ease-in-out sm:leading-5 truncate"
        v-model="mutableValue"
        :placeholder="placeholder"
        :disabled="disabled || disabled_pass"
        :maxlength="maxlength"
        :class="{
          'bg-gray-200 cursor-not-allowed': disabled || disabled_pass,
          'text-lg py-5 px-5': big != null && big,
          'text-sm px-3 py-2 xxl:px-4 xxl:py-3 2xl:px-5 2xl:py-4':
            big == null || !big,
          'border-red-500': error && errorMsg != '',
          'border-indigo-600': !(error && errorMsg != ''),
        }"
        @blur="blur()"
        @focus="focus()"
      />
      <div
        v-if="type !== 'password' && voiceInput && !disabled"
        class="absolute right-0 inset-y-0 pt-1 pr-6 flex items-center cursor-pointer"
      >
        <SpeechToText
          @result="(result) => updateMutable(result)"
          @startRecognition="startRecognition"
          @stopRecognition="stopRecognition"
        ></SpeechToText>
      </div>

      <div
        v-if="type == 'password' && isEye"
        class="absolute inset-y-0 right-0 pt-1 pr-6 flex items-center cursor-pointer"
        @click="switchVisibility"
      >
        <icon
          v-if="typeField == 'password'"
          name="eye"
          class="text-indigo-600"
        />
        <icon v-else name="eye-off" class="text-indigo-600" />
      </div>

      <!-- Display value when hover -->
      <transition
        enter-active-class="duration-300 delay-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-300"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="
            typeField != 'password' &&
            tooltipValue &&
            mutableValue != null &&
            mutableValue != ''
          "
          class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-12 z-30 p-3 text-sm w-max-content w-max max-w-128"
        >
          {{ mutableValue }}
        </div>
      </transition>
    </div>
    <div v-if="error" class="text-red-500 text-sm">
      {{ errorMsg }}
    </div>
  </div>
</template>

<script>
import Icon from '../../components/Icon';
import InfoBulle from '../../components/InfoBulle';
import Constants from './../../constants';
import SpeechToText from './SpeechToText.vue';

export default {
  props: {
    type: String,
    name: String,
    libelle: {
      type: String,
      required: false,
      default: '',
    },
    value: [String, Number],
    necessary: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: String,
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: Boolean,
    msgError: {
      type: String,
      required: false,
      default: '',
    },
    maxlength: Number,
    labelLibelle: String,
    big: Boolean,
    required: Boolean,
    notEye: Boolean,
    inherits: {
      type: Boolean,
      required: false,
      default: false,
    },
    min: Number,
    max: Number,
    newPassword: {
      type: Boolean,
      required: false,
      default: false,
    },
    replaceTooltipLibelle: {
      type: String,
      required: false,
      default: null,
    },
    libelleStyle: {
      type: String,
      required: false,
      default: 'text-sm text-gray-600',
    },
    libelleIcon: {
      type: String,
    },
    libelleIconStyle: {
      type: String,
      required: false,
      default: 'text-pink-600 h-2.5',
    },
    voiceInput: {
      type: Boolean,
      required: false,
      default: true,
    }
  },

  components: {
    SpeechToText,
    Icon,
    InfoBulle,
  },

  data: function () {
    return {
      mutableValue: this.value,
      valueBeforeSpeech: undefined,
      errorMsg: this.msgError,
      disabled_pass: false,
      typeField: this.type,
      tooltipLabel: false,
      tooltipValue: false,
      tooltipLibelle: false,
      progressCount: true,
      textLibelle: '&nbsp;',
      isRequired: false,
      isEye: true,
      constants: Constants,
    };
  },

  mounted() {
    // Manage edit permission for neopass pages
    if (this.$route.path.includes('form/neopass')) {
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];

      if (
        this.$can(page + '_edit', idpass) ||
        page === Constants.PAGE_NEOPASS_FORM_DOCUMENTS
      ) {
        this.disabled_pass = false;
      } else {
        this.disabled_pass = true;
      }
    } else {
      this.disabled_pass = false;
    }

    //assign "necessary" prop value to "progressCount" data if this prop is filled
    if (this.necessary != undefined && !this.necessary) {
      this.progressCount = false;
    }

    //assign text to textLibelle if prop Libelle is filled
    if (this.libelle != undefined && this.libelle != null) {
      this.textLibelle = this.libelle;
    }

    //assign "required" prop value to "isRequired" data if this prop is filled
    if (this.required != undefined && this.required != null) {
      this.isRequired = this.required;
    }

    //according to prop notEye, if input type is "password", then display or not the in the input
    if (this.notEye != undefined && this.notEye != null) {
      this.isEye = !this.notEye;
    }

    if (this.msgError) {
      this.errorMsg = this.msgError;
    }
  },

  methods: {
    startRecognition () {
      this.valueBeforeSpeech = this.mutableValue;
    },

    stopRecognition() {
      this.valueBeforeSpeech = undefined;
    },

    updateMutable(value) {
      this.mutableValue = `${this.valueBeforeSpeech ?? ''} ${value}`;
    },

    displayLabelTooltip(e) {
      if (e.x < (2 * window.outerWidth) / 3) {
        document
          .querySelectorAll(".tooltip-Label[name='" + this.name + "']")[0]
          .classList.remove('right-0');
      }

      this.tooltipLabel = !this.tooltipLabel;
    },
    switchVisibility() {
      this.typeField = this.typeField === 'password' ? 'text' : 'password';
    },
    forceHideTooltipLabel(e) {
      if (
        e.target.classList.contains('tooltip-Label') &&
        e.target.name == this.name
      ) {
        this.tooltipLabel = !this.tooltipLabel;
      } else {
        if (this.tooltipLabel) this.tooltipLabel = false;
      }
    },
    blur() {
      if (!this.mutableValue || this.mutableValue.length === 0) {
        this.errorMsg = '';
        this.$emit('loseFocus');
        return;
      }

      if (
        (this.typeField === 'tel' &&
          !/^\d+$/.test(this.mutableValue.replaceAll(/\s/g, ''))) ||
        (this.typeField === 'tel' &&
          this.mutableValue.replaceAll(/\s/g, '').length != 10)
      ) {
        this.errorMsg =
          'Vous devez saisir un numéro de téléphone à 10 chiffres';
        this.$emit('loseFocus');
        return;
      } else if (
        this.typeField === 'email' &&
        !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.mutableValue
        )
      ) {
        this.errorMsg = 'Veuillez saisir une adresse email valide';
        this.$emit('loseFocus');
        return;
      }
      this.$emit('loseFocus');
    },
    focus() {
      this.$emit('focusInput');
    },
  },

  watch: {
    mutableValue() {
      /* if (!this.mutableValue) {
        return;
      } */

      this.$emit('input', this.mutableValue);

      if (!this.mutableValue || this.mutableValue.length === 0) {
        this.errorMsg = '';
        return;
      }

      if (this.typeField === 'number' && !/^\d+$/.test(this.mutableValue)) {
        this.errorMsg = 'Vous devez utiliser des chiffres sans espaces';
      } else if (
        this.maxlength &&
        this.mutableValue &&
        this.mutableValue.length >= this.maxlength &&
        this.typeField != 'tel'
      ) {
        this.errorMsg =
          'Vous avez atteint la taille maximum de ' +
          this.maxlength +
          ' caractères.';
      } else if (
        this.maxlength &&
        this.mutableValue &&
        this.mutableValue.length < this.maxlength
      ) {
        this.errorMsg = '';
      } else if (this.msgError) {
        this.errorMsg = this.msgError;
      } else {
        this.errorMsg = '';
      }
    },

    value() {
      this.mutableValue = this.value;
    },

    msgError() {
      this.errorMsg = this.msgError;
    },
  },

  beforeDetroy() {
    this.typeField = this.type;
  },

  directives: {
    clickOutside: {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
};
</script>
